import React, { memo } from "react";
import { Draggable } from "react-beautiful-dnd";
import { Box } from "@mui/material";

import { SchedulerBar } from "../ScheduleBarChart/SchedulerBar";
import { StyledDraggableBox } from "./styles";
import { getInvertedStyle } from "./helper";

const SchedulerDraggableBar = memo(
  ({ element, order, isDraggingOver, isActive, view, targetDate }) => (
    <Box
      {...(element?.draggableProps || {})}
      className={`HubDroppable-box HubDroppable-box-${order}`}
    >
      <Draggable
        draggableId={`${element.id}`}
        index={order}
        isDragDisabled={!!element?.started}
      >
        {(provided, snapshot) => (
          <StyledDraggableBox
            className="HubDraggable-root"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...getInvertedStyle(
                provided.draggableProps,
                snapshot.isDragging,
                snapshot.isDropAnimating,
                isDraggingOver,
              ),
            }}
          >
            <SchedulerBar
              {...element}
              isDragging={snapshot.isDragging}
              isActive={isActive}
              view={view}
              targetDate={snapshot.isDragging ? targetDate : null}
            />
          </StyledDraggableBox>
        )}
      </Draggable>
    </Box>
  ),
  (prev, next) =>
    prev.element === next.element &&
    prev.order === next.order &&
    prev.isDraggingOver === next.isDraggingOver &&
    prev.isActive === next.isActive &&
    prev.view === next.view &&
    prev.targetDate === next.targetDate,
);

export default SchedulerDraggableBar;
